import {Component, store} from 'Generic';
import {addClass, removeClass} from 'Generic/lib';

export default class PackageBoxes extends Component {
  constructor() {
    super({
      store,
      state: store.state,
    });
  }

  render() {
    const selectedPlanCode = this.state.selected_plan?.code;

    removeClass('.teams-plan-box', 'active-plan');
    addClass(`.teams-plan-box[teams-plan-code="${selectedPlanCode}"]`, 'active-plan');

    removeClass('.pro-cart-container .cart-box', 'active-plan');
    addClass(`.pro-cart-container .cart-box[data-plan-code="${selectedPlanCode}"]`, 'active-plan');

    removeClass('.pro-cart-container td.plus-border-v2', 'selected');
    addClass(`.pro-cart-container td.plus-border-v2[data-plan-code="${selectedPlanCode}"]`, 'selected');

    removeClass('.pro-cart-container td.popular-row', 'selected');
    addClass(`.pro-cart-container td.popular-row[data-plan-code="${selectedPlanCode}"]`, 'selected');
  }
}
